import type { TelephonicEntryDetailsType } from '../../../services/commonCheckout/types/CheckoutSessionsResponse';

export const isTelephonicEntryReady = (
  telephonicEntryDetails: TelephonicEntryDetailsType | undefined,
): boolean => {
  return (
    !!telephonicEntryDetails &&
    telephonicEntryDetails.status === 'IN_PROGRESS' &&
    !!telephonicEntryDetails.url
  );
};
